<template>
  <div>
    <Main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
    >
      <template #header>
        <h6 class="m-0">
          {{ $l('form_label_orderSku') || '订单明细' }}
        </h6>
      </template>
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import { multiply, subtract } from '@/libs/util.number.js'
export default {
  components: { Main },
  props: {
    disabled: { type: Boolean, default: false },
    evgBulkOrderCode: { type: String, default: '' },
    listEvgPackingSchemeCode: { type: Array, default: () => [] },
  },
  data() {
    return { tableData: [], loading: false }
  },
  methods: {
    async getData() {
      this.loading = true
      this.tableData = await this.getDataApi()
      this.loading = false
    },
    getDataApi() {
      return this.disabled ? this.getOrderSku() : this.getPackingSku()
    },
    async getPackingSku() {
      if (!this.listEvgPackingSchemeCode?.length) return []

      return this.$api
        .ecomEvgBulkOrderSkuSchemeListApi({
          listEvgPackingSchemeCode: this.listEvgPackingSchemeCode,
        })
        .then((res) => {
          const data = res?.body?.data || []
          return data.map((item) => {
            const {
              salesPrice,
              actualPrice,
              unitInContainerQty: unitQty,
            } = item
            const unitAmount = multiply(unitQty, salesPrice)
            const actualAmount = multiply(unitQty, actualPrice)
            const amountDiff = multiply(
              subtract(salesPrice, actualPrice),
              unitQty
            )
            return {
              ...item,
              unitQty,
              unitPrice: salesPrice,
              unitAmount,
              actualAmount,
              amountDiff,
            }
          })
        })
        .catch(() => [])
    },
    async getOrderSku() {
      const params = { evgBulkOrderCode: this.evgBulkOrderCode }
      const res = await this.$api
        .ecomEvgBulkOrderSkuListApi(params)
        .catch(() => null)
      return res?.body?.data || []
    },
  },
}
</script>
